document.addEventListener("DOMContentLoaded", function () {
    setTimeout(function () {
        const wrapper = document.querySelector('.picky-accordion__wrapper');
        const items = document.querySelectorAll('.picky-accordion__item');
        const uploadForm = document.querySelector('.upload-file-form'); // Select the entire div

        if (wrapper && items.length > 1 && uploadForm) {
            const lastItem = items[items.length - 1]; // Get the last item
            wrapper.insertBefore(lastItem, wrapper.firstChild); // Move it to the top

            // Find the .picky-accordion__content inside the moved item
            const content = lastItem.querySelector('.picky-accordion__content');
            if (content) {
                // Move .upload-file-form to be the first element inside .picky-accordion__content
                content.prepend(uploadForm);
            }
        }
    }, 3000); // Delay of 1 second (1000 milliseconds)
});
